/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistogramDTO } from './HistogramDTO';
import {
    HistogramDTOFromJSON,
    HistogramDTOFromJSONTyped,
    HistogramDTOToJSON,
} from './HistogramDTO';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface HistogramSeriesAttributeDTO
 */
export interface HistogramSeriesAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof HistogramSeriesAttributeDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof HistogramSeriesAttributeDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * 
     * @type {HistogramDTO}
     * @memberof HistogramSeriesAttributeDTO
     */
    last?: HistogramDTO;
    /**
     * 
     * @type {number}
     * @memberof HistogramSeriesAttributeDTO
     */
    lastStep?: number;
}



/**
 * Check if a given object implements the HistogramSeriesAttributeDTO interface.
 */
export function instanceOfHistogramSeriesAttributeDTO(value: object): value is HistogramSeriesAttributeDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    return true;
}

export function HistogramSeriesAttributeDTOFromJSON(json: any): HistogramSeriesAttributeDTO {
    return HistogramSeriesAttributeDTOFromJSONTyped(json, false);
}

export function HistogramSeriesAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistogramSeriesAttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'last': json['last'] == null ? undefined : HistogramDTOFromJSON(json['last']),
        'lastStep': json['lastStep'] == null ? undefined : json['lastStep'],
    };
}

export function HistogramSeriesAttributeDTOToJSON(value?: HistogramSeriesAttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'last': HistogramDTOToJSON(value['last']),
        'lastStep': value['lastStep'],
    };
}

